// kufer-search.js
import { loadUserFavorites, toggleFavoriteRequest } from "../kufer-utils/kufer-favorites";
import { populateCourseCard } from "../kufer-utils/kufer-course-card";

export function initializeKuferSearch() {
  // --- SELEKTOREN ---
  const form = document.getElementById("kufer-search-form");
  const input = document.getElementById("search_term");
  const resultsList = document.getElementById("kufer-results-list");
  const loadingMessage = document.querySelector(".loading-message");
  const template = document.querySelector("[data-course-template]");
  const filterFachb = document.getElementById("filter_fachb");
  const filterOrt = document.getElementById("filter_ortid")?.value || "";
  const filterOrtName = document.getElementById("filter_ortname");
  const filterDatum = document.getElementById("filter_beginndat");
  const filterKategorie = document.getElementById("filter_kategorie");
  const filterLaufend = document.getElementById("filter_laufend");
  const filterKeyword = document.getElementById("filter_keyword");
  const filterFirma = document.getElementById("filter_firma");
  const filterThema = document.getElementById("filter_thema");
  const filterReset = document.getElementById("filter_reset");

  const fachbereicheDataContainer =
    document.getElementById("fachbereiche-data") || null;
  const fachbereicheData = fachbereicheDataContainer
    ? JSON.parse(fachbereicheDataContainer.textContent)
    : {};

  const pagingControls = document.getElementById("kufer-paging-controls");
  const prevButton = document.getElementById("kufer-page-prev");
  const nextButton = document.getElementById("kufer-page-next");

  // --- NEUE PAGINIERUNGS-LOGIK ---

  // Wie viele Kurse zeigen wir pro Klick an? (z.B. 5 oder 12)
  let clientLimitString = document.getElementById("filter_limit");
  const clientLimit = parseInt(
    clientLimitString ? clientLimitString.value : 5,
    10,
  );

  // Wie viele Kurse holen wir pro API-Anfrage?
  const apiBatchSize = 48;

  let apiPage = 1; // Welche 99er-Seite haben wir von der API geladen?
  let clientPage = 1; // Welche 12er-Seite ZEIGEN wir gerade an?
  let fetchedCoursesStore = []; // Lokaler Cache für die 99 Kurse
  let currentFilters = {}; // Aktuelle Filter zwischenspeichern

  // --- VALIDIERUNG ---
  if (!form || !resultsList || !template || !pagingControls) {
    /*console.warn(
      "Kufer Search: Wichtige HTML-Elemente nicht gefunden. Funktion inaktiv.",
    );*/
    return;
  }

  // --- FUNKTION 1: Holt einen 99er-Batch von der API ---
  /**
   * Holt einen großen Batch (99) von der API, speichert ihn und rendert die erste Client-Seite.
   * @param {object} filters - Die Suchfilter.
   * @param {number} pageToFetch - Die API-Seite (Batch-Nummer), die geholt werden soll.
   * @param {boolean} renderLastPage - (Für "Zurück") Soll die letzte Client-Seite dieses Batches gerendert werden?
   */
  function fetchBatchAndRender(filters, pageToFetch, renderLastPage = false) {
    if (loadingMessage) loadingMessage.style.display = "block";
    pagingControls.style.display = "none";
    resultsList.innerHTML = ""; // Container leeren
    currentFilters = filters; // Filter für spätere API-Aufrufe (nächster Batch) speichern

    //const baseUrl = `${window.location.origin}/wp-json/mmmake-kufer/v2/kurse`;
    //const params = new URLSearchParams();

    const baseUrl = `${window.location.origin}/kufer-api.php`;
    const params = new URLSearchParams();

    // WICHTIG: Den Endpunkt-Pfad als Parameter mitschicken
    params.append("endpoint", "kurse");

    if (filters.search) params.append("search", filters.search);
    if (filters.fachb) params.append("fachb", filters.fachb);
    if (filters.ortid) params.append("ort_id", filters.ortid);
    if (filters.ortname) params.append("ortname", filters.ortname);
    if (filters.beginndat) params.append("beginndat", filters.beginndat);
    if (filters.kategorie_id)
      params.append("kategorie_id", filters.kategorie_id);
    if (filters.laufend) params.append("laufend", filters.laufend);
    if (filters.keyword) params.append("keyword", filters.keyword);
    if (filters.firma_id) params.append("firma_id", filters.firma_id);
    if (filters.thema_id) params.append("thema_id", filters.thema_id);

    // WICHTIG: Wir holen jetzt immer `apiBatchSize` (99) Kurse
    params.append("limit", apiBatchSize);
    params.append("page", pageToFetch);

    apiPage = pageToFetch; // Aktuelle API-Seite merken

    const restUrl = `${baseUrl}?${params.toString()}`;
    //console.log(restUrl);
    fetch(restUrl)
      .then((response) => response.json())
      .then((data) => {
        if (loadingMessage) loadingMessage.style.display = "none";

        fetchedCoursesStore = data; // Die 99 Kurse im Cache speichern

        if (renderLastPage) {
          // Springe zur letzten Client-Seite des neuen Batches (für "Zurück")
          clientPage = Math.ceil(fetchedCoursesStore.length / clientLimit) || 1;
        } else {
          // Standard: Zeige die erste Client-Seite des neuen Batches
          clientPage = 1;
        }

        renderClientPage(clientPage);
      })
      .catch((error) => {
        if (loadingMessage) loadingMessage.style.display = "none";
        resultsList.innerHTML =
          "<li>Fehler beim Laden der Suchergebnisse.</li>";
        console.error("API-Fehler:", error);
      });
  }

  // --- FUNKTION 2: Rendert eine Client-Seite (z.B. 12 Kurse) aus dem Cache ---
  /**
   * Nimmt die Kurse aus `fetchedCoursesStore` und rendert die angeforderte Client-Seite.
   * @param {number} page - Die Client-Seite (Slice-Nummer), die angezeigt werden soll.
   */
  function renderClientPage(page) {
    resultsList.innerHTML = ""; // Container immer leeren

    const start = (page - 1) * clientLimit;
    const end = start + clientLimit;
    const coursesToRender = fetchedCoursesStore.slice(start, end);

    if (fetchedCoursesStore.length === 0 && apiPage === 1) {
      resultsList.innerHTML =
        "<p class='course-list__entry-not-found'>Keine Kurse für diese Suchkriterien gefunden.</p>";
      pagingControls.style.display = "none";
      return;
    }

    // Die eigentliche HTML-Render-Logik aufrufen
    renderCoursesHtml(coursesToRender);

    // --- Paging-Buttons-Logik aktualisieren ---
    const totalClientPagesInBatch = Math.ceil(
      fetchedCoursesStore.length / clientLimit,
    );
    // Haben wir eine volle 99er-Seite bekommen? Wenn ja, gibt es potenziell mehr auf der API.
    const hasApiMorePages = fetchedCoursesStore.length === apiBatchSize;

    const isFirstOverall = apiPage === 1 && page === 1;
    const isLastOverall = !hasApiMorePages && page === totalClientPagesInBatch;

    // "Zurück"-Button
    prevButton.classList.toggle("disabled", isFirstOverall);

    // "Weiter"-Button
    nextButton.classList.toggle("disabled", isLastOverall);

    // Paging-Container anzeigen, wenn es überhaupt was zu blättern gibt
    if (!isFirstOverall || !isLastOverall) {
      pagingControls.style.display = "grid";
    } else {
      pagingControls.style.display = "none";
    }
  }

  // --- FUNKTION 3: Baut das HTML für die Kurse ---
  // Status/Datum/Titel/Tags/Favoriten-Anzeige kommen aus dem mit
  // kufer-kurs-loader.js geteilten populateCourseCard() (siehe kufer-course-card.js).
  function renderCoursesHtml(courses) {
    const fragment = document.createDocumentFragment();
    courses.forEach((kurs) => {
      const { courseEntry, favBtn } = populateCourseCard(template, kurs, {
        fachbereicheData,
      });

      if (favBtn) {
        favBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          toggleFavoriteRequest(kurs.knr, favBtn);
        });
      }

      fragment.appendChild(courseEntry);
    });
    resultsList.appendChild(fragment);
  }

  // --- EVENT LISTENER ---
  function getFilters() {
    return {
      search: input.value.trim(),
      fachb: filterFachb.value,
      ortid: filterOrt,
      ortname: filterOrtName ? filterOrtName.value : "",
      beginndat: filterDatum ? filterDatum.value : "",
      kategorie_id: filterKategorie ? filterKategorie.value : "",
      laufend: filterLaufend.checked ? "1" : "",
      keyword: filterKeyword ? filterKeyword.value.trim() : "",
      firma_id: filterFirma ? filterFirma.value : "",
      thema_id: filterThema ? filterThema.value : "",
    };
  }

  // --- Filter zurücksetzen ---
  if (filterReset) {
    filterReset.addEventListener("click", function (e) {
      e.preventDefault();

      // 1. Alle Formularfelder leeren / zurücksetzen
      if (input) input.value = "";
      if (filterFachb) filterFachb.value = "";
      if (filterOrtName) filterOrtName.value = "";
      if (filterDatum) filterDatum.value = "";
      if (filterKategorie) filterKategorie.value = "";
      if (filterThema) filterThema.value = "";
      if (filterKeyword) filterKeyword.value = "";
      if (filterLaufend) filterLaufend.checked = false;
      // Falls 'filterFirma' existiert, auch zurücksetzen:
      if (filterFirma) filterFirma.value = "";

      // 2. URL-Suchparameter in der Adressleiste komplett bereinigen
      const cleanUrl = new URL(
        window.location.origin + window.location.pathname,
      );
      history.pushState({}, "", cleanUrl);

      // 3. Suche neu auslösen (lädt die ungefilterte Liste von API-Seite 1)
      form.requestSubmit();
    });
  }

  // --- Formular Absenden (Immer API-Aufruf, Seite 1) ---
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    const filters = getFilters();

    // URL in der Adressleiste aktualisieren
    const newUrl = new URL(window.location);
    if (filters.search) {
      newUrl.searchParams.set("s", filters.search);
    } else {
      newUrl.searchParams.delete("s");
    }
    // (Hier könntest du auch die anderen Filter in die URL schreiben)
    history.pushState({}, "", newUrl);

    // Starte eine NEUE Suche: Hol' den ersten 99er-Batch (API-Seite 1)
    fetchBatchAndRender(filters, 1);
  });

  // --- "Weiter"-Button ---
  nextButton.addEventListener("click", function (event) {
    event.preventDefault();
    if (nextButton.classList.contains("disabled")) return;

    const totalClientPagesInBatch = Math.ceil(
      fetchedCoursesStore.length / clientLimit,
    );

    if (clientPage < totalClientPagesInBatch) {
      // --- Fall 1: Noch Kurse im lokalen Cache ---
      clientPage++;
      renderClientPage(clientPage);
    } else {
      // --- Fall 2: Lokaler Cache aufgebraucht, nächsten 99er-Batch holen ---
      const hasApiMorePages = fetchedCoursesStore.length === apiBatchSize;
      if (hasApiMorePages) {
        fetchBatchAndRender(currentFilters, apiPage + 1);
      }
    }
  });

  // --- "Zurück"-Button ---
  prevButton.addEventListener("click", function (event) {
    event.preventDefault();
    if (prevButton.classList.contains("disabled")) return;

    if (clientPage > 1) {
      // --- Fall 1: Einfach eine Client-Seite zurück ---
      clientPage--;
      renderClientPage(clientPage);
    } else {
      // --- Fall 2: Wir sind auf Client-Seite 1, aber nicht auf API-Seite 1 ---
      if (apiPage > 1) {
        // Vorherigen 99er-Batch holen und dessen LETZTE Seite anzeigen
        fetchBatchAndRender(currentFilters, apiPage - 1, true);
      }
    }
  });

  // --- Initiale Suche beim Laden der Seite ---
  const urlParams = new URLSearchParams(window.location.search);
  const initialSearchTerm = urlParams.get("s")?.trim() || "";
  input.value = initialSearchTerm;

  // Setze Filterwerte aus der URL
  if (filterFachb) {
    const fachbUrlParameter = urlParams.get("fachb")?.trim() || "";
    const fachbSelectedOption = filterFachb.querySelector("option[selected]");
    if (fachbUrlParameter) {
      //filterFachb.value = urlParams.get("fachb")?.trim() || "";
      filterFachb.value = fachbUrlParameter;
    } else if (fachbSelectedOption) {
      filterFachb.value = fachbSelectedOption.value;
    } else {
      filterFachb.value = "";
    }
  }
  if (filterOrtName) {
    filterOrtName.value = urlParams.get("ortname")?.trim() || "";
  }
  if (filterDatum) {
    filterDatum.value = urlParams.get("beginndat")?.trim() || "";
  }
  if (filterKategorie) {
    const kategorieUrlParameter = urlParams.get("kategorie_id")?.trim() || "";
    const kategorieSelectedOption =
      filterKategorie.querySelector("option[selected]");
    if (kategorieUrlParameter) {
      filterKategorie.value = kategorieUrlParameter;
    } else if (kategorieSelectedOption) {
      filterKategorie.value = kategorieSelectedOption.value;
    } else {
      filterKategorie.value = "";
    }
  }
  if (filterLaufend) {
    filterLaufend.checked = urlParams.get("laufend") === "1";
  }
  if (filterKeyword) {
    filterKeyword.value = urlParams.get("keyword")?.trim() || "";
  }
  if (filterFirma) {
    filterFirma.value = urlParams.get("firma_id")?.trim() || "";
  }
  if (filterThema) {
    const themaUrlParameter = urlParams.get("thema_id")?.trim() || "";
    const themaSelectedOption = filterThema.querySelector("option[selected]");
    if (themaUrlParameter) {
      filterThema.value = themaUrlParameter;
    } else if (themaSelectedOption) {
      filterThema.value = themaSelectedOption.value;
    } else {
      filterThema.value = "";
    }
  }

  // Zentraler Favoriten-State (geteilt mit kufer-kurs-loader.js und der Detailseite).
  loadUserFavorites();
  form.requestSubmit();
}
